import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source"];

  copy(event) {
    event.preventDefault();
    if (!this.hasSourceTarget) return;
    const text = this.sourceTarget.textContent.trim();
    if (!text) return;

    const button = event.currentTarget;
    const label = button.getAttribute("aria-label") || "Copy";

    navigator.clipboard.writeText(text).then(() => {
      const originalText = button.textContent;
      button.textContent = button.dataset.copyFeedback || "Copied!";
      button.setAttribute("aria-label", "Copied");
      setTimeout(() => {
        button.textContent = originalText;
        button.setAttribute("aria-label", label);
      }, 2000);
    });
  }
}
